export default __webpack_public_path__ + "static/media/none.6de08320.svg";